// patient panel routes
const profile = 'patient-panel/profile/'
export const profileShow = profile + 'show'
export const profileStore = profile + 'store'
export const profileUpdate = profile + 'update'
export const profileCheckPrevious = profile + 'check-previous-request-status'
export const submitCenterChangeRequest = profile + 'center-change-request'
// Notification Awareness
const notificationAwareness = 'patient-panel/notification-awareness/'
export const notificationAwarenessList = notificationAwareness + 'list'
export const notificationAwarenessStatusToggle = notificationAwareness + 'toggle-status'
// Notification Awareness wish List
const wishList = 'patient-panel/wish-list/'
export const wishListListApi = wishList + 'list'
export const wishListStoreApi = wishList + 'store'
export const wishListUpdateApi = wishList + 'update'
// Assistive Device Application
const deviceApplicaton = 'patient-panel/assistive-device-applicaton/'
export const assistiveDeviceApplicatonListApi = deviceApplicaton + 'list'
export const assistiveDeviceApplicatonStoreApi = deviceApplicaton + 'store'
export const assistiveDeviceApplicatonUpdateApi = deviceApplicaton + 'update'
export const getPatientDetailsApi = deviceApplicaton + 'patient-details'

// Apply For job List
export const applyForJob = 'patient-panel/apply-for-job/'
export const applyForJobList = applyForJob + 'list'
export const jobApplyStoreApi = applyForJob + 'store'
export const jobApplyCircularShow = applyForJob + 'show'
export const jobFairCirculationBaseUrlApi = 'job-fair-management/job-fair-circulations/'
export const jobFairCirculationShowApi = jobFairCirculationBaseUrlApi + 'show'
export const reportHeadingList = '/configuration/report-heading/detail'

// Resume Api Routes Qualification....
export const resumeBaseUrlApi = 'patient-panel/resume-application/'
export const resumeQualificationListApi = resumeBaseUrlApi + 'list-qualification'
export const resumeQualificationStoreApi = resumeBaseUrlApi + 'store-qualification'
export const resumeQualificationUpdateApi = resumeBaseUrlApi + 'update-qualification'
export const resumeQualificationdeleteApi = resumeBaseUrlApi + 'delete-qualification'
export const resumeViewApi = resumeBaseUrlApi + 'view-resume'
export const resumeEmploymentListApi = resumeBaseUrlApi + 'list-employment'
export const resumeEmploymentStoreApi = resumeBaseUrlApi + 'store-employment'
export const resumeEmploymentUpdateApi = resumeBaseUrlApi + 'update-employment'
export const resumeEmploymentdeleteApi = resumeBaseUrlApi + 'delete-employment'

// Job Confirmation List Route
export const jobConfirmationBaseUrlApi = 'patient-panel/confirmation-list/'
export const jobConfirmationListApi = jobConfirmationBaseUrlApi + 'list'

// patient panel dashboard routes
export const dashboardPatientPanelApi = 'patient-panel/dashboard/dashboard-list'
export const disabilityTypeListNewApi = 'configuration/disability-type/listnew'
export const CvBankresumeViewApi = 'job-fair-management/cv-bank/resumeview'
